import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import CloseButton from './CloseButton';

import vw from 'styles/utils';

import videosData from 'data/video';

function VideoModal(props) {
  const { show, selectedVideoIndex, title, onClickCloseButton, onClickPrevButton, onClickNextButton } = props;

  return (
    <Root show={show}>
      <Container>
        <PrevButton src={require('assets/images/icons/previous.png')} alt="prev button" onClick={onClickPrevButton}/>
        <Iframe src={videosData[selectedVideoIndex].src} title={title ? title : ''} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
        <NextButton src={require('assets/images/icons/next.png')} alt="next button" onClick={onClickNextButton}/>
        <CloseButton onClick={onClickCloseButton} />
      </Container>
    </Root>
  )
}

VideoModal.propTypes = {
  show: PropTypes.bool,
  selectedVideoIndex: PropTypes.number,
  title: PropTypes.string,
  onClickCloseButton: PropTypes.func
}

const Root = styled.div`
  width: 100%;
  height: 100vh;
  display: ${props => props.show ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99;
`;

const Container = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* width: 1062px;
  height: 585px; */
  position: relative;

  ${vw('width', 260, 730, 1062)}
  ${vw('height', 150, 360, 585)}
`;

const Iframe = styled.iframe`
  width: 80%;
  height: 80%;
`;

const PrevButton = styled.img`
  /* width: 32px;
  height: 32px; */
  position: absolute;
  top: 50%;
  /* left: 30px; */
  transform: translate3d(0, -50%, 0);
  cursor: pointer;

  ${vw('width', 10, 25, 32)}
  ${vw('height', 10, 25, 32)}
  ${vw('left', 10, 20, 32)}
`;

const NextButton = styled.img`
  /* width: 32px;
  height: 32px; */
  position: absolute;
  top: 50%;
  /* right: 30px; */
  transform: translate3d(0, -50%, 0);
  cursor: pointer;

  ${vw('width', 10, 25, 32)}
  ${vw('height', 10, 25, 32)}
  ${vw('right', 10, 20, 32)}
`;

export default VideoModal
